module.exports = __webpack_public_path__ + "img/回首頁.6e9dd445.png";